import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_dashboard/funding-requests")({
  beforeLoad: ({ context: { store } }) => {
    if (store.getState().userRole !== "customer") {
      throw redirect({ to: "/" })
    }
  },
})
